import { isMobile } from '@/const/browser';
import { INVITE_CODE } from '@/const/constant';

export const codeKey = 'code';

/**
 * 从 sessionStorage 获取 source 追踪码
 */
export function getCode() {
  const code = sessionStorage.getItem(codeKey);
  return code ?? '';
}

/**
 * 从 URL 中获取邀请码
 */
export function getInviteCode(): string | null {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(INVITE_CODE);
}

export interface AuthParamsOptions {
  anonymousId?: string | null;
}

/**
 * 匿名 id 仅用于登录后绑定匿名项目。
 * provider 读取失败时不能阻断登录流程，这里统一兜底为 null。
 */
export function getOptionalAnonymousId(getAnonymousId?: () => string | null | undefined): string | null {
  try {
    return getAnonymousId?.() || null;
  } catch {
    return null;
  }
}

/**
 * 构建注册/登录的通用参数（包含 device、inviteCode 和 source）
 * 用于统一处理设备类型、邀请码和来源追踪参数
 */
export function buildAuthParams<T extends Record<string, any>>(
  params: T,
  options: AuthParamsOptions = {},
): T & { device: 'web' | 'mobile'; inviteCode?: string; source?: string; anonymousId?: string } {
  const inviteCode = getInviteCode();
  const source = getCode();
  const device = isMobile ? 'mobile' : 'web';

  return {
    device,
    ...(inviteCode ? { inviteCode } : {}),
    ...(source ? { source } : {}),
    ...(options.anonymousId ? { anonymousId: options.anonymousId } : {}),
    ...params,
  };
}

export function buildAuthParamsWithAnonymous<T extends Record<string, any>>(
  params: T,
  getAnonymousId?: () => string | null | undefined,
) {
  return buildAuthParams(params, {
    anonymousId: getOptionalAnonymousId(getAnonymousId),
  });
}
